/**
 * Parsuje czas odjazdu z formatu API: "1899-12-30THH:MM:SS" lub "1899-12-31THH:MM:SS"
 * 1899-12-30 = ten sam dzień, 1899-12-31 = następny dzień (linie nocne)
 */
export function parseDepartureTime(timeStr) {
  if (!timeStr) return null;
  const isNextDay = timeStr.startsWith('1899-12-31');
  const timePart = timeStr.split('T')[1];
  if (!timePart) return null;
  const [h, m] = timePart.split(':').map(Number);
  return { hour: h, minute: m, isNextDay };
}

/**
 * Zwraca dzisiejszą datę w formacie YYYY-MM-DD
 */
export function getTodayDateStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/**
 * Sortuje linie numerycznie: "2" przed "10", litery po cyfrach ("N1" po "99")
 */
export function sortRoutesByNumber(routes) {
  return [...routes].sort((a, b) => {
    const aNum = parseInt(a.routeShortName, 10);
    const bNum = parseInt(b.routeShortName, 10);
    const aIsNum = !isNaN(aNum);
    const bIsNum = !isNaN(bNum);

    if (aIsNum && bIsNum) return aNum - bNum;
    if (aIsNum) return -1;
    if (bIsNum) return 1;
    return a.routeShortName.localeCompare(b.routeShortName);
  });
}

/**
 * Sortuje godziny w kolejności rozkładowej: [4,5,...,23,0,1,2,3]
 */
export function sortHours(hours) {
  return [...hours].sort((a, b) => {
    const aAdj = a < 4 ? a + 24 : a;
    const bAdj = b < 4 ? b + 24 : b;
    return aAdj - bAdj;
  });
}
